import {
  WALLET_LOADING,
  WALLET_ERROR,

  WALLET_GET_LIST,
  WALLET_GET_FILTERS,
  WALLET_GET_SINGLE,
} from "actions/wallet/constants";

const initialState = {
  loading: false,
  errors: [],

  walletList: [],
  walletFilters: [],
  walletSingle: {},
  bankTypes: []
};

export default function (state = initialState, action) {
  switch (action.type) {
    case WALLET_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case WALLET_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case WALLET_GET_LIST:
      return {
        ...state,
        loading: false,
        errors: [],
        walletList: action.payload,
      };
    case WALLET_GET_FILTERS:
      return {
        ...state,
        loading: false,
        errors: [],
        walletFilters: action.payload.content,
      };
    case WALLET_GET_SINGLE:
      return {
        ...state,
        loading: false,
        errors: [],
        walletSingle: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/walletReducer.js